<app-loader [hidden]="!loaderDisplayed"></app-loader>

<ng-container *ngIf="isUserAuthenticated; else login">
  <div class="main-container">
    <app-nav></app-nav>
    <div class="main" [ngClass]="{ 'nav-open-padding nav-open': navOpen }">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

<ng-template #login>
  <app-login></app-login>
</ng-template>
